export class SituacaoPcm {
  Codigo: string;
  IdStatusPc: number;
  DsStatusPc: string;

  constructor(obj?: any) {
    if (obj) {
      if (obj.Codigo) this.Codigo = obj.Codigo;
      if (obj.IdStatusPc) this.IdStatusPc = obj.IdStatusPc;
      if (obj.DsStatusPc) this.DsStatusPc = obj.DsStatusPc;
    }
  }
}
